"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../utils/style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 100%;\n  background-color: ", ";\n  position: absolute;\n  left: ", "px;\n  top: ", "px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 100%;\n  border: 1px solid;\n  border-color: ", ";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: ", "px;\n  margin-top: ", "px;\n  box-sizing: border-box;\n  animation: ", " ", "s linear infinite;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 100%;\n  background-color: ", ";\n  position: absolute;\n  left: ", "px;\n  top: ", "px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 100%;\n  border: 1px solid;\n  border-color: ", ";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: ", "px;\n  margin-top: ", "px;\n  box-sizing: border-box;\n  animation: ", " ", "s linear infinite;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;;\n  height: ", "px;;\n  border-radius: 100%;\n  background-color: ", ";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: ", "px;\n  margin-top: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n  /* overflow: hidden; */\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var rotate = (0, _styledComponents.keyframes)(_templateObject());

var LoadContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.size === 'small' ? 44 : props.size === 'large' ? 56 : 50;
}, function (props) {
  return props.size === 'small' ? 44 : props.size === 'large' ? 56 : 50;
});

var Sun = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.size === 'small' ? 2 : props.size === 'large' ? 6 : 4;
}, function (props) {
  return props.size === 'small' ? 2 : props.size === 'large' ? 6 : 4;
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.size === 'small' ? -1 : props.size === 'large' ? -3 : -2;
}, function (props) {
  return props.size === 'small' ? -1 : props.size === 'large' ? -3 : -2;
});

var FirstTrack = _styledComponents.default.div(_templateObject4(), function (props) {
  return props.size === 'small' ? 24 : props.size === 'large' ? 36 : 30;
}, function (props) {
  return props.size === 'small' ? 24 : props.size === 'large' ? 36 : 30;
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.size === 'small' ? -12 : props.size === 'large' ? -18 : -15;
}, function (props) {
  return props.size === 'small' ? -12 : props.size === 'large' ? -18 : -15;
}, rotate, function (props) {
  return props.speed || 2;
});

var Earth = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.size === 'small' ? 4 : props.size === 'large' ? 8 : 6;
}, function (props) {
  return props.size === 'small' ? 4 : props.size === 'large' ? 8 : 6;
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.size === 'small' ? 1 : props.size === 'large' ? 1 : 0;
}, function (props) {
  return props.size === 'small' ? 1 : props.size === 'large' ? 3 : 2;
});

var SecondTrack = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.size === 'small' ? 54 : props.size === 'large' ? 66 : 60;
}, function (props) {
  return props.size === 'small' ? 54 : props.size === 'large' ? 66 : 60;
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.size === 'small' ? -27 : props.size === 'large' ? -33 : -30;
}, function (props) {
  return props.size === 'small' ? -27 : props.size === 'large' ? -33 : -30;
}, rotate, function (props) {
  return props.speed * 1.5 || 3;
});

var Mars = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.size === 'small' ? 6 : props.size === 'large' ? 10 : 8;
}, function (props) {
  return props.size === 'small' ? 6 : props.size === 'large' ? 10 : 8;
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.size === 'small' ? 6 : props.size === 'large' ? 8 : 7;
}, function (props) {
  return props.size === 'small' ? 1 : props.size === 'large' ? 3 : 2;
});

var SolarSystemLoading = function SolarSystemLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      color = _ref.color,
      speed = _ref.speed,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return _react.default.createElement(LoadContainer, {
    style: style,
    size: size
  }, _react.default.createElement(Sun, {
    color: color,
    size: size
  }), _react.default.createElement(FirstTrack, {
    color: color,
    speed: speed,
    size: size
  }, _react.default.createElement(Earth, {
    color: color,
    size: size
  })), _react.default.createElement(SecondTrack, {
    color: color,
    speed: speed,
    size: size
  }, _react.default.createElement(Mars, {
    color: color,
    size: size
  })));
};

var _default = SolarSystemLoading;
exports.default = _default;